<template>
    <van-cell-group>
        <van-field v-model="formData.ophone"
                   label="原手机号"
                   placeholder="请输入原手机号"
                   input-align="right"
                   :error="formValidate&&!formData.ophone"
        />
        <van-field v-model="formData.phone"
                   label="新手机号"
                   placeholder="请再次输入新手机号"
                   :error="formValidate&&!formData.phone"
                   input-align="right"/>
        <van-field
                v-model="formData.code"
                center clearable label="短信验证码"
                placeholder="请输入短信验证码"
                :error="formValidate&&!formData.code"
        >
            <van-button slot="button" size="small" type="danger" background-color="red" @click="getCode">
                {{clockSecond>0? clockSecond+'s获取验证码':'获取验证码'}}
            </van-button>
        </van-field>
        <div class="btn">
            <van-button type="danger" round size="large" @click="formSave" v-if="!loading">确定</van-button>
            <van-button type="danger" round size="large" v-else>确定中...</van-button>
        </div>
    </van-cell-group>
</template>
<style scoped>
    .btn {
        padding: 0 0.3rem;
        margin-top: 0.3rem;
    }

</style>

<script>
    import {Toast} from 'vant';

    export default {
        name: 'SetPhone',
        comments: {
            Toast
        },
        data: function () {
            return {
                formData: {
                    ophone: '',
                    phone: '',
                    code: '',
                },
                clockSecond: 0,
                formValidate: false,
                loading: false,
            }
        },
        filter: {},
        mounted() {
            document.title = '修改手机'
        },
        destroyed() {
        },
        methods: {
            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                this.$api.get('/api/user/phonecode', {}, (res) => {
                    Toast(res.msg)
                    that.clockSecond = 60;
                    var t = setInterval(function () {
                        if (that.clockSecond > 0) {
                            that.clockSecond = that.clockSecond - 1
                        } else {
                            clearInterval(t);
                        }
                    }, 1000)
                })
            },


            formSave() {
                let that = this;
                for (let field in that.formData) {
                    if (field != '_pspt' && !that.formData[field]) {
                        that.formValidate = true
                        return;
                    }
                }

                that.loading = true;
                that.$api.get('/api/user/editPhone', that.formData, (res) => {
                    that.$router.go(-1)
                    that.loading = false;
                    Toast.success("修改成功");
                }, (res) => {
                    Toast(res.msg);
                    that.loading = false;

                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// SetPhone.vue?13afcd89